var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoDrag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 102,
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104602",
    "data-name": "Group 104602",
    transform: "translate(0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226",
    "data-name": "Rectangle 146226",
    transform: "translate(-0.032)",
    fill: "#84ffba",
    stroke: "#03e67c",
    strokeWidth: 1,
    strokeDasharray: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 102,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Two",
    transform: "translate(48.968 86)",
    fill: "#29e67c",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.872,
    y: 0
  }, "Video")), /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate_black_24dp",
    transform: "translate(22.072 10.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M0,0H54.259V54.259H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "play-button",
    transform: "translate(6.398 6.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104565",
    "data-name": "Group 104565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64211",
    "data-name": "Path 64211",
    d: "M20.73,0a20.73,20.73,0,1,0,20.73,20.73A20.73,20.73,0,0,0,20.73,0Zm8.73,21.391a1.481,1.481,0,0,1-.665.665v.007L16.95,27.986a1.481,1.481,0,0,1-2.143-1.333V14.808a1.481,1.481,0,0,1,2.143-1.325L28.8,19.405A1.481,1.481,0,0,1,29.461,21.391Z",
    fill: "#29e67c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDrag);
export default __webpack_public_path__ + "static/media/Video_drag.0356f6f14da6f5a1e6c8bb13e0f42dd6.svg";
export { ForwardRef as ReactComponent };